import { render, staticRenderFns } from "./svgPreview.vue?vue&type=template&id=a0c4dabe&scoped=true&"
import script from "./svgPreview.vue?vue&type=script&lang=js&"
export * from "./svgPreview.vue?vue&type=script&lang=js&"
import style0 from "./svgPreview.vue?vue&type=style&index=0&id=a0c4dabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c4dabe",
  null
  
)

export default component.exports